import {
  Button,
  CircularProgress,
  Grid,
  TextField,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@material-ui/core";
import { Auth } from "aws-amplify";
import { LinearProgress } from "@mui/material";
import React, { useEffect, useRef, useLayoutEffect } from "react";
import { Checkmark } from "react-checkmark";
import { FaCheckCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
import styles from "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import PersonIcon from "@mui/icons-material/Person";
import SmartToyIcon from "@mui/icons-material/SmartToy";
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  MessageInput,
  AttachmentButton,
  SendButton,
  InputToolbox,
  TypingIndicator,
} from "@chatscope/chat-ui-kit-react";
import { useState } from "react";
import AWS from "aws-sdk";
import Swal from "sweetalert2";
export default function Ibold({ title, link }) {
  const [csvFile, setCsvFile] = useState(null);
  const [csvload, setcsvload] = useState(false);
  const [trainload, setTrainload] = useState(false);
  const [answerload, setAnswerload] = useState(false);
  const [displayText, setDisplayText] = useState("");
  // const [question, setQuestion] = useState("");
  const [output, setOutput] = useState("");
  const [error, setError] = useState("");
  const [feedbackResponses, setFeedbackResponses] = useState([]);
  const [deleteError, setdeleteError] = useState("");
  // const [selectedModel, setSelectedModel] = useState("meta.llama2-13b-chat-v1");
  // const [modeltext, setModelText] = useState("LLAMA 13b");
  const [userName, setUsername] = useState("");
  const timetaken = useRef(0);

  async function signOut() {
    try {
      await Auth.signOut({ global: true });
      window.location.reload();
    } catch (error) {
      // console.log('error signing out: ', error);
    }
  }
  const [messages, setMessages] = useState([]);
  const [genaiaccess, setgenaiaccess] = useState(false);
  const [isInputDisabled, setIsInputDisabled] = useState(true);
  const [transcript, setTranScript] = useState("");
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const messagesEndRef = useRef(null);
  const [progress, setProgress] = useState(0);
  const [isStartChatStarted, setIsStartChatStarted] = useState(false);

  // calculate progress
  const calculateProgress = (flags) => {
    let progress = 0;
    if (flags.activity_1_condition) progress += 20;
    if (flags.activity_2_condition) progress += 20;
    if (flags.activity_3_condition) progress += 20;
    if (flags.activity_4_condition) progress += 20;
    return progress;
  };

  // useEffect(() => {
  //   const messageList = messagesEndRef.current?.parentNode;
  //   if (messageList) {
  //     messageList.scrollTop = messageList.scrollHeight;
  //   }
  // }, [messages]);

  useEffect(() => {
    if (messages.length > 0) {
      const lastMessage = messages[messages.length - 1]; // Get the last message

      const messageList = messagesEndRef.current?.parentNode;
      if (messageList) {
        if (lastMessage.direction === "incoming") {
          // Apply the 3-second delay for incoming messages
          setTimeout(() => {
            messageList.scrollTop = messageList.scrollHeight;
          }, 3000);
        } else {
          // No delay for outgoing messages
          messageList.scrollTop = messageList.scrollHeight;
        }
      }
    }
  }, [messages]);

  useEffect(() => {
    if (transcript.length > 0) {
      // console.log("Original Transcript: ", transcript);
      const formattedTranscript = formatResponse(transcript);
      // console.log("Formatted Response: ", formattedTranscript);
      let index = 0;
      const intervalId = setInterval(() => {
        setDisplayText((prev) => prev + formattedTranscript[index]);
        index++;
        if (index === formattedTranscript.length) {
          clearInterval(intervalId);
          setTranScript("");
        }
      }, 1);
    }
  }, [transcript]);

  const formatResponse = (response) => {
    // Replacing markdown-like headers with HTML headers
    const headers = response
      .replace(/(######\s?)(.*?)\n/g, "<h6>$2</h6>")
      .replace(/(#####\s?)(.*?)\n/g, "<h5>$2</h5>")
      .replace(/(####\s?)(.*?)\n/g, "<h4>$2</h4>")
      .replace(/(###\s?)(.*?)\n/g, "<h3>$2</h3>")
      .replace(/(##\s?)(.*?)\n/g, "<h2>$2</h2>")
      .replace(/(#\s?)(.*?)\n/g, "<h1>$2</h1>");

    // Splitting and replacing bold markers
    let responseArray = headers.split("**");
    let newResponse = "";
    for (let i = 0; i < responseArray.length; i++) {
      if (i % 2 === 0) {
        newResponse += responseArray[i];
      } else {
        newResponse += "<b>" + responseArray[i] + "</b>";
      }
    }

    // Replace asterisks and newlines for proper HTML formatting
    newResponse = newResponse.replace(/\*/g, "<br/>");
    newResponse = newResponse.replace(/\n/g, "<br/>");
    newResponse = newResponse.replace(/\\"/g, '"');

    return newResponse;
  };

  useEffect(() => {
    var username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser"
    );
    var userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`
    );
    var jsondata = JSON.parse(userdata);
    let email =
       jsondata["UserAttributes"][jsondata["UserAttributes"].length - 2][
        "Value"
      ];
    email.includes("genai2244") ? setgenaiaccess(true) : setgenaiaccess(false);

    if (userdata) {
      setUsername(username);
    }
  }, []);

  const handleSendMessage = (messageText, inputId) => {
    if (messageText.trim() === "") {
      return;
    }
    // if (currentPayload.activity_4_condition === true) {
    //   messageText = `Manager: ${messageText}`;
    // }
    // Create a new message object
    const newMessage = {
      id: Math.random().toString(),
      text: messageText,
      sender: "User",
      direction: "outgoing",
    };
    // Update the messages state by adding the new message
    setMessages((prevMessages) => [...prevMessages, newMessage]);
    handleQuestion1(messageText);
  };

  const handleStart = async () => {
    setIsStartChatStarted(true);
    console.log("Handle Start is calling");

    // Reset any previous conversation and disable input field during loading
    setMessages([]);
    setIsInputDisabled(true);
    setAnswerload(true);
    setTranScript("");
    setDisplayText("");

    const username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser"
    );

    // Reset the current payload for a fresh start
    const resetPayload = {
      users_response: "",
      activity_1_condition: true,
      activity_2_condition: false,
      activity_3_condition: false,
      activity_4_condition: false,
      activity_5_condition: false,
      activity_1_1st_condition: true,
      activity_1_2nd_condition: false,
      activity_2_1st_condition: false,
      activity_2_2nd_condition: false,
      activity_2_3rd_condition: false,
      activity_3_1st_condition: false,
      activity_3_2nd_condition: false,
      activity_4_1st_condition: false,
      activity_4_2nd_condition: false,
      activity_4_3rd_condition: false,
      activity_5_1st_condition: false,
      activity_5_2nd_condition: false,
      conversation_history_list: [],
      evaluation_list: [],
      count: 0,
      first_response: false,
      activity_3_feedback: [],
      feedback: "",
      index: 0,
      question_1_count: 1,
    };

    // Prepare the initial payload
    // const initialPayload = {
    //   ...resetPayload,
    //   users_response: "",
    //   welcome_message_event: true,
    // };

    setCurrentPayload(resetPayload);
    // setCurrentPayload(initialPayload);
    console.log("Initial Payload before sending:", resetPayload);

    try {
      // Send a POST request to the backend with the initial payload
      const response = await fetch(
        "https://nkmpdg6qksrynr6hmij22s5tu40ukxyv.lambda-url.ap-south-1.on.aws/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(resetPayload), // Send the reset payload
        }
      );

      const data = await response.json();
      console.log("First Response data:", data);

      // Update the messages with the backend response (e.g., welcome message)
      setMessages((prevMessages) => [
        ...prevMessages,
        { text: data.message.response, direction: "incoming" },
      ]);

      setCurrentPayload((prevPayload) => ({
        ...prevPayload,
        ...data.message,
      }));

      setAnswerload(false);
      setIsInputDisabled(false);
    } catch (error) {
      console.error("Error fetching initial message:", error);

      // Stop loading and allow retry
      setAnswerload(false);
      setIsInputDisabled(false);
    }
  };

  const [currentPayload, setCurrentPayload] = useState({
    users_response: "",
    activity_1_condition: true,
    activity_2_condition: false,
    activity_3_condition: false,
    activity_4_condition: false,
    activity_5_condition: false,
    activity_1_1st_condition: true,
    activity_1_2nd_condition: false,
    activity_2_1st_condition: false,
    activity_2_2nd_condition: false,
    activity_2_3rd_condition: false,
    activity_3_1st_condition: false,
    activity_3_2nd_condition: false,
    activity_4_1st_condition: false,
    activity_4_2nd_condition: false,
    activity_4_3rd_condition: false,
    activity_5_1st_condition: false,
    activity_5_2nd_condition: false,
    conversation_history_list: [],
    evaluation_list: [],
    count: 0,
    first_response: false,
    activity_3_feedback: [],
    feedback: "",
    index: 0,
    question_1_count: 1,
  });

  // const handleQuestion1 = async (question) => {
  //   setTranScript("");
  //   setDisplayText("");

  //   if (question.length > 0) {
  //     timetaken.current = 0;

  //     // Start timer to track time taken for the request
  //     let time = setInterval(() => {
  //       timetaken.current = parseFloat(timetaken.current) + 0.1;
  //     }, 100);

  //     setAnswerload(true);
  //     console.log("requesting");

  //     const updatedPayload = {
  //       ...currentPayload, // Get the latest state
  //       conversation_list: [
  //         ...(currentPayload.conversation_list || []),
  //         question,
  //       ], // Add the question to conversation list
  //       users_response: question,
  //     };

  //     console.log("Payload being sent in the second request:", updatedPayload);

  //     try {
  //       // Send the updated payload to the backend
  //       const response = await fetch(
  //         "https://nkmpdg6qksrynr6hmij22s5tu40ukxyv.lambda-url.ap-south-1.on.aws/",
  //         {
  //           method: "POST",
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //           body: JSON.stringify(updatedPayload), // Send the updated payload
  //         }
  //       );

  //       const data = await response.json();
  //       console.log("Second Response Data:", data);

  //       setAnswerload(false);

  //       // Extract response message and feedback
  //       const chatbotMessage = data.message.response || "No message available";
  //       const chatbotConclusion = data.message.feedback || "";
  //       // console.log(chatbotConclusion, "111");

  //       // Only update the flags or fields returned by the backend
  //       const updatedFlags = {
  //         // Update only if the backend provides the value, otherwise keep the current value
  //         users_response:
  //           data.message.users_response !== undefined
  //             ? data.message.users_response
  //             : currentPayload.users_response,
  //         activity_1_condition:
  //           data.message.activity_1_condition !== undefined
  //             ? data.message.activity_1_condition
  //             : currentPayload.activity_1_condition,
  //         activity_2_condition:
  //           data.message.activity_2_condition !== undefined
  //             ? data.message.activity_2_condition
  //             : currentPayload.activity_2_condition,
  //         activity_3_condition:
  //           data.message.activity_3_condition !== undefined
  //             ? data.message.activity_3_condition
  //             : currentPayload.activity_3_condition,
  //         activity_4_condition:
  //           data.message.activity_4_condition !== undefined
  //             ? data.message.activity_4_condition
  //             : currentPayload.activity_4_condition,
  //         activity_1_1st_condition:
  //           data.message.activity_1_1st_condition !== undefined
  //             ? data.message.activity_1_1st_condition
  //             : currentPayload.activity_1_1st_condition,
  //         activity_1_2nd_condition:
  //           data.message.activity_1_2nd_condition !== undefined
  //             ? data.message.activity_1_2nd_condition
  //             : currentPayload.activity_1_2nd_condition,
  //         activity_2_1st_condition:
  //           data.message.activity_2_1st_condition !== undefined
  //             ? data.message.activity_2_1st_condition
  //             : currentPayload.activity_2_1st_condition,
  //         activity_2_2nd_condition:
  //           data.message.activity_2_2nd_condition !== undefined
  //             ? data.message.activity_2_2nd_condition
  //             : currentPayload.activity_2_2nd_condition,
  //         activity_2_3rd_condition:
  //           data.message.activity_2_3rd_condition !== undefined
  //             ? data.message.activity_2_3rd_condition
  //             : currentPayload.activity_2_3rd_condition,
  //         index:
  //           data.message.index !== undefined
  //             ? data.message.index
  //             : currentPayload.index,
  //         question_1_count:
  //           data.message.question_1_count !== undefined
  //             ? data.message.question_1_count
  //             : currentPayload.question_1_count,
  //       };

  //       // Calculate progress directly after updating flags.
  //       setCurrentPayload((prevPayload) => {
  //         const mergedPayload = {
  //           ...prevPayload,
  //           ...updatedFlags, // Merge flags from backend response
  //           conversation_list: [
  //             ...prevPayload.conversation_list,
  //             chatbotMessage,
  //           ], // Add chatbot message
  //         };

  //         // Calculate progress after merging
  //         const newProgress = calculateProgress(mergedPayload);
  //         setProgress(newProgress);
  //         console.log("Progress: " + newProgress);
  //         return mergedPayload;
  //       });

  //       // Add chatbot message to the UI
  //       const newMessage = {
  //         id: Math.random().toString(),
  //         text: chatbotMessage,
  //         sender: "Chatbot",
  //         direction: "incoming",
  //       };

  //       clearInterval(time);
  //       setMessages((prevMessages) => [...prevMessages, newMessage]);
  //       setTranScript(chatbotConclusion);

  //       // Add feedback conclusion to the feedback list
  //       if (chatbotConclusion.trim()) {
  //         setFeedbackResponses((prevFeedback) => [
  //           ...prevFeedback,
  //           {
  //             text: `Feedback ${prevFeedback.length + 1}`,
  //             conclusion: chatbotConclusion,
  //             id: Math.random().toString(),
  //           },
  //         ]);
  //       }
  //     } catch (error) {
  //       console.error("Error occurred during the request:", error);
  //       setAnswerload(false);

  //       // Show an error message in the chat
  //       const errorMessage = {
  //         id: Math.random().toString(),
  //         text: "Something went wrong",
  //         sender: "Chatbot",
  //         direction: "incoming",
  //       };
  //       setMessages((prevMessages) => [...prevMessages, errorMessage]);
  //       clearInterval(time);
  //     }
  //   } else {
  //     setError("Please enter a question");
  //   }
  // };

  const handleQuestion1 = async (question) => {
    setTranScript("");
    setDisplayText("");

    if (question.length > 0) {
      timetaken.current = 0;

      // Start timer to track time taken for the request
      let time = setInterval(() => {
        timetaken.current = parseFloat(timetaken.current) + 0.1;
      }, 100);

      setAnswerload(true);
      console.log("requesting");

      const updatedPayload = {
        ...currentPayload,
        users_response: question,
      };

      console.log("Payload being sent in the second request:", updatedPayload);

      try {
        // Send the updated payload to the backend
        const response = await fetch(
          "https://nkmpdg6qksrynr6hmij22s5tu40ukxyv.lambda-url.ap-south-1.on.aws/",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(updatedPayload), // Send the updated payload
          }
        );

        const data = await response.json();
        console.log("Second Response Data:", data);

        setAnswerload(false);

        // Extract response message and feedback
        const chatbotMessage = data.message.response || "No message available";
        const chatbotConclusion = data.message.feedback || "";

        // Only update the flags or fields returned by the backend
        const updatedFlags = {
          // Update only if the backend provides the value, otherwise keep the current value
          users_response:
            data.message.users_response !== undefined
              ? data.message.users_response
              : currentPayload.users_response,
          feedback:
            data.message.feedback !== undefined
              ? data.message.feedback
              : currentPayload.feedback,
          conversation_history_list:
            data.message.conversation_history_list ||
            currentPayload.conversation_history_list,
          evaluation_list:
            data.message.evaluation_list || currentPayload.evaluation_list,
          activity_3_feedback:
            data.message.activity_3_feedback ||
            currentPayload.activity_3_feedback,
          count:
            data.message.count !== undefined
              ? data.message.count
              : currentPayload.count,
          index:
            data.message.index !== undefined
              ? data.message.index
              : currentPayload.index,
          question_1_count:
            data.message.question_1_count !== undefined
              ? data.message.question_1_count
              : currentPayload.question_1_count,
          activity_1_condition:
            data.message.activity_1_condition !== undefined
              ? data.message.activity_1_condition
              : currentPayload.activity_1_condition,
          activity_2_condition:
            data.message.activity_2_condition !== undefined
              ? data.message.activity_2_condition
              : currentPayload.activity_2_condition,
          activity_3_condition:
            data.message.activity_3_condition !== undefined
              ? data.message.activity_3_condition
              : currentPayload.activity_3_condition,
          activity_4_condition:
            data.message.activity_4_condition !== undefined
              ? data.message.activity_4_condition
              : currentPayload.activity_4_condition,
          activity_5_condition:
            data.message.activity_5_condition !== undefined
              ? data.message.activity_5_condition
              : currentPayload.activity_5_condition,
          activity_1_1st_condition:
            data.message.activity_1_1st_condition !== undefined
              ? data.message.activity_1_1st_condition
              : currentPayload.activity_1_1st_condition,
          activity_1_2nd_condition:
            data.message.activity_1_2nd_condition !== undefined
              ? data.message.activity_1_2nd_condition
              : currentPayload.activity_1_2nd_condition,
          activity_2_1st_condition:
            data.message.activity_2_1st_condition !== undefined
              ? data.message.activity_2_1st_condition
              : currentPayload.activity_2_1st_condition,
          activity_2_2nd_condition:
            data.message.activity_2_2nd_condition !== undefined
              ? data.message.activity_2_2nd_condition
              : currentPayload.activity_2_2nd_condition,
          activity_2_3rd_condition:
            data.message.activity_2_3rd_condition !== undefined
              ? data.message.activity_2_3rd_condition
              : currentPayload.activity_2_3rd_condition,
          activity_3_1st_condition:
            data.message.activity_3_1st_condition !== undefined
              ? data.message.activity_3_1st_condition
              : currentPayload.activity_3_1st_condition,
          activity_3_2nd_condition:
            data.message.activity_3_2nd_condition !== undefined
              ? data.message.activity_3_2nd_condition
              : currentPayload.activity_3_2nd_condition,
          activity_4_1st_condition:
            data.message.activity_4_1st_condition !== undefined
              ? data.message.activity_4_1st_condition
              : currentPayload.activity_4_1st_condition,
          activity_4_2nd_condition:
            data.message.activity_4_2nd_condition !== undefined
              ? data.message.activity_4_2nd_condition
              : currentPayload.activity_4_2nd_condition,
          activity_4_3rd_condition:
            data.message.activity_4_3rd_condition !== undefined
              ? data.message.activity_4_3rd_condition
              : currentPayload.activity_4_3rd_condition,
          activity_5_1st_condition:
            data.message.activity_5_1st_condition !== undefined
              ? data.message.activity_5_1st_condition
              : currentPayload.activity_5_1st_condition,
          activity_5_2nd_condition:
            data.message.activity_5_2nd_condition !== undefined
              ? data.message.activity_5_2nd_condition
              : currentPayload.activity_5_2nd_condition,
          first_response:
            data.message.first_response !== undefined
              ? data.message.first_response
              : currentPayload.first_response,
          activity_3_feedback:
            data.message.activity_3_feedback !== undefined
              ? data.message.activity_3_feedback
              : currentPayload.activity_3_feedback,
          feedback:
            data.message.feedback !== undefined
              ? data.message.feedback
              : currentPayload.feedback,
          index:
            data.message.index !== undefined
              ? data.message.index
              : currentPayload.index,
          question_1_count:
            data.message.question_1_count !== undefined
              ? data.message.question_1_count
              : currentPayload.question_1_count,
        };

        // Calculate progress directly after updating flags.
        setCurrentPayload((prevPayload) => {
          const mergedPayload = {
            ...prevPayload,
            ...updatedFlags, // Add chatbot message
          };

          // Calculate progress after merging
          const newProgress = calculateProgress(mergedPayload);
          setProgress(newProgress);
          console.log("Progress: " + newProgress);
          return mergedPayload;
        });

        // Add chatbot message to the UI
        const newMessage = {
          id: Math.random().toString(),
          text: chatbotMessage,
          sender: "Chatbot",
          direction: "incoming",
        };

        clearInterval(time);
        setMessages((prevMessages) => [...prevMessages, newMessage]);
        setTranScript(chatbotConclusion);

        // Add feedback conclusion to the feedback list
        if (chatbotConclusion.trim()) {
          setFeedbackResponses((prevFeedback) => [
            ...prevFeedback,
            {
              text: `Feedback ${prevFeedback.length + 1}`,
              conclusion: chatbotConclusion,
              id: Math.random().toString(),
            },
          ]);
        }
      } catch (error) {
        console.error("Error occurred during the request:", error);
        setAnswerload(false);

        // Show an error message in the chat
        const errorMessage = {
          id: Math.random().toString(),
          text: "Something went wrong",
          sender: "Chatbot",
          direction: "incoming",
        };
        setMessages((prevMessages) => [...prevMessages, errorMessage]);
        clearInterval(time);
      }
    } else {
      setError("Please enter a question");
    }
  };

  const handleFeedbackClick = (response) => {
    setDisplayText(formatResponse(response.conclusion)); // Show the full conclusion in the feedback window
  };

  return (
    <div
      style={{
        backgroundColor: "#FFFFFF",
        minHeight: "100vh",
        padding: "1rem",
      }}
    >
      {/* Header Section */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1rem",
        }}
      >
        <Link to={link}>
          <Button variant="contained" component="span" color="primary">
            Back
          </Button>
        </Link>
        <h2 style={{ fontWeight: "bold", color: "#333333" }}>{title}</h2>
        <Button
          style={{
            backgroundColor: "#ffa502",
          }}
          variant="contained"
          onClick={() => {
            signOut();
          }}
          color="primary"
          component="span"
        >
          Sign Out
        </Button>
      </div>

      {/* Main Content Section */}
      {genaiaccess ? (
        <div
          style={{
            display: "flex",
            height: "85vh",
            // gap: "1rem",
            // padding: "1rem",
          }}
        >
          {/* Chat Window (7 parts) */}
          <div
            style={{
              flex: 7,
              backgroundColor: "#F7F8FA",
              padding: "1rem",
              borderRadius: "1rem",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "1rem",
                fontFamily: "'Outfit', sans-serif",
              }}
            >
              <h3 style={{ margin: 0 }}>
                <strong>Chat Window</strong>
              </h3>
              <Button
                variant="contained"
                color="primary"
                onClick={handleStart}
                style={{ fontSize: "0.9rem", padding: "0.5rem 1rem" }}
              >
                {isStartChatStarted ? "Restart Chat" : "Start Chat"}
              </Button>
            </div>

            {/* <LinearProgress
              variant="determinate"
              value={progress}
              style={{
                borderRadius: "4px",
                height: "8px",
                marginBottom: "1rem",
              }}
            /> */}
            <MainContainer
              style={{
                borderRadius: "1rem",
                backgroundColor: "#FFFFFF",
                boxShadow: "inset 0 2px 8px rgba(0, 0, 0, 0.05)",
                flex: 1,
                display: "flex",
                flexDirection: "column",
                height: "100%",
              }}
            >
              <ChatContainer
                style={{
                  padding: "1rem",
                  backgroundColor: "#FFFFFF",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  flexGrow: 1,
                  overflow: "hidden",
                }}
              >
                <MessageList
                  style={{
                    color: "#333333",
                    backgroundColor: "#FFFFFF",
                    flexGrow: 1,
                    overflowY: "auto",
                    marginBottom: "1rem",
                    paddingRight: "1rem",
                    maxHeight: "calc(100% - 60px)",
                  }}
                  typingIndicator={
                    answerload && (
                      <TypingIndicator content="chatbot is typing..." />
                    )
                  }
                  autoScrollToBottomOnMount={true}
                >
                  {Array.isArray(messages) &&
                    messages.map((message, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "flex-end",
                          marginBottom: "1rem",
                          justifyContent:
                            message.direction === "outgoing"
                              ? "flex-end"
                              : "flex-start",
                        }}
                      >
                        {message.direction === "incoming" && (
                          <>
                            <img
                              src="/assets/images/chatbot1.png"
                              alt="Chatbot Icon"
                              style={{
                                marginRight: "0.5rem",
                                width: "38px",
                                height: "38px",
                                borderRadius: "50%",
                              }}
                            />
                            <div
                              style={{
                                fontFamily: "'Outfit', sans-serif",
                                fontSize: "1rem",
                                backgroundColor: "#E0E0E0",
                                padding: "0.75rem 1.5rem",
                                borderRadius: "20px 20px 20px 0",
                                maxWidth: "91%",
                                wordWrap: "break-word",
                              }}
                            >
                              <CharacterByCharacter
                                message={message.text}
                                messagesEndRef={messagesEndRef}
                              />
                            </div>
                          </>
                        )}

                        {message.direction === "outgoing" && (
                          <>
                            <div
                              style={{
                                fontFamily: "'Outfit', sans-serif",
                                fontSize: "1rem",
                                // backgroundColor: "#6EA9D7 ",
                                backgroundColor: "#9FC8E4",
                                padding: "0.75rem",
                                borderRadius: "20px 20px 0 20px",
                                maxWidth: "70%",
                                wordWrap: "break-word",
                                // textAlign: "right",
                                color: "#333333",
                                marginRight: "0.5rem",
                              }}
                            >
                              {message.text}
                            </div>
                            <img
                              src="/assets/images/man_icon.png"
                              alt="User Icon"
                              style={{
                                marginLeft: "0.5rem",
                                width: "38px",
                                height: "38px",
                                borderRadius: "50%",
                              }}
                            />
                          </>
                        )}
                      </div>
                    ))}
                  <div ref={messagesEndRef} />
                </MessageList>
                <MessageInput
                  attachButton={false}
                  placeholder="Type your first message here..."
                  onSend={(messageText) => {
                    let sanitizedMessage = messageText.replace(/&nbsp;/g, " ");

                    // Preserve leading spaces with &nbsp;
                    sanitizedMessage = sanitizedMessage.replace(
                      /^\s+/,
                      (match) => {
                        return match
                          .split("")
                          .map(() => "&nbsp;")
                          .join("");
                      }
                    );

                    handleSendMessage(sanitizedMessage.trim());
                  }}
                  disabled={
                    isInputDisabled ||
                    transcript.length > 0 ||
                    currentPayload.satisfaction_condition === true
                  }
                  style={{
                    fontFamily: "'Outfit', sans-serif",
                    borderRadius: "8px",
                    backgroundColor: "#F0F2F5",
                    color: "#121212",
                    padding: "0.75rem",
                    border: "1px solid #E0E0E0",
                    boxSizing: "border-box",
                    fontSize: "1rem",
                    width: "100%",
                    position: "relative",
                    zIndex: 10,
                  }}
                />
              </ChatContainer>
            </MainContainer>
          </div>

          {/* Right Side (3 parts) */}

          <div
            style={{
              flex: 3,
              fontFamily: "'Outfit', sans-serif",
              padding: "1rem",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "1rem",
              }}
            >
              <h3 style={{ margin: 0 }}>
                <strong>Feedback Window</strong>
              </h3>
            </div>
            <div
              style={{
                color: "#333333",
                padding: "1rem",
                border: "1px solid #D1DBE3",
                borderRadius: "1rem",
                backgroundColor: "#FFFFFF",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                flex: 1,
                minHeight: "550px",
                fontSize: "1rem",
                overflowY: "auto",
              }}
            >
              {/* Feedback Buttons */}
              <div
                style={{
                  marginBottom: "1rem",
                  display: "flex",
                  flexWrap: "wrap", // Allow buttons to wrap to the next line
                  gap: "10px", // Optional: Add spacing between buttons
                }}
              >
                {feedbackResponses.map((response, index) => (
                  <Button
                    key={response.id}
                    variant="contained"
                    color="primary"
                    onClick={() => handleFeedbackClick(response)} // Display full feedback on click
                    // style={{
                    //   flex: "1 1 calc(33.33% - 10px)", // Ensure 3 buttons per row with space between
                    //   textTransform: "none",
                    //   marginBottom: "10px", // Spacing between rows
                    // }}
                    style={{
                      flex: "1 1 calc(33.33% - 10px)",
                      textTransform: "none",
                      marginBottom: "10px",
                      width: "100%",
                      minWidth: "120px",
                      maxWidth: "200px",
                      padding: "10px 20px",
                      boxSizing: "border-box",
                    }}
                  >
                    {response.text} {/* Shows Feedback 1, Feedback 2, etc. */}
                  </Button>
                ))}
              </div>

              {displayText.length > 0 ? (
                <div
                  style={{
                    color: "#333333",
                    fontFamily: "'Outfit', sans-serif",
                    wordWrap: "break-word",
                    whiteSpace: "pre-wrap",
                  }}
                  dangerouslySetInnerHTML={{ __html: displayText }}
                ></div>
              ) : (
                "Response will be displayed here"
              )}
            </div>
          </div>
        </div>
      ) : (
        <h2 style={{ color: "#333333", textAlign: "center" }}>
          You do not have access to use this section.
        </h2>
      )}
    </div>
  );
}

const CharacterByCharacter = ({ message, messagesEndRef }) => {
  const [displayedText, setDisplayedText] = useState("");

  useEffect(() => {
    const formattedMessage =
      typeof message === "string" ? message : String(message);

    let responseArray = formattedMessage.split("**");
    let newResponse = "";
    for (let i = 0; i < responseArray.length; i++) {
      if (i % 2 === 0) {
        newResponse += responseArray[i];
      } else {
        newResponse += "<b>" + responseArray[i] + "</b>";
      }
    }

    newResponse = newResponse.replace(/\*/g, "<br/>");
    newResponse = newResponse.replace(/\n/g, "<br/>");
    newResponse = newResponse.replace(/\\"/g, '"');
    let currentIndex = 0;
    const intervalId = setInterval(() => {
      setDisplayedText((prev) => prev + newResponse[currentIndex]);
      currentIndex += 1;
      // Trigger scroll every time a new character is displayed
      if (messagesEndRef.current) {
        messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
      }
      if (currentIndex === newResponse.length) {
        clearInterval(intervalId);
      }
    }, 1);

    return () => clearInterval(intervalId);
  }, [message, messagesEndRef]);

  return <span dangerouslySetInnerHTML={{ __html: displayedText }} />;
};
